<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21V19H19V5H12V3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H12Z"
      fill="#383838"
    />
    <path
      d="M9.375 8.45L8 7L3 12L8 17L9.375 15.55L6.825 13L15 13L15 11L6.825 11L9.375 8.45Z"
      fill="#383838"
    />
  </svg>
</template>
